<template lang="html">
  <dropdown class="dropdown_accounts" menu-right v-if="hasControls">
    <a @click.prevent class="dropdown-trigger">
      <span class="cap-icon cap-icon-menu-hamburger cap-icon_circle center-block"></span>
    </a>
    <template v-slot:dropdown>
      <li :class="repeatLIClass" v-if="document.repeatable">
        <a :href="repeatUrl">{{ $t('Повторить платеж') }}</a>
      </li>
      <li v-if="document.historyBeneficiarySearchAvailable">
        <a :href="correspondentSearchUrl">{{ $t('Поиск по этому корреспонденту') }}</a>
      </li>
      <template v-if="pdfAvailable">
        <li>
          <a :href="pdfDownloadUrl">{{ $t('Скачать PDF') }}</a>
        </li>
        <li>
          <a :href="pdfPrintUrl" target="_blank">{{ $t('Печать PDF') }}</a>
        </li>
      </template>
    </template>
  </dropdown>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {Dropdown} from 'uiv';
import {
  historyDocumentPdfAvailable,
  historyDocumentPdfUrl
} from "capitalist-shared/src/finance/documents";

// Vue.use(uiv);

@Component({
  name: 'legacy-history-document-controls',
  components: {Dropdown}
})
export default class LegacyHistoryDocumentControls extends Vue {
  @Prop({required: true})
  document: any

  @Prop({default: ''})
  repeatUrl!: string

  @Prop({default: ''})
  correspondentSearchUrl!: string

  get pdfAvailable() {
    return historyDocumentPdfAvailable(this.document);
  }

  get pdfDownloadUrl() {
    return historyDocumentPdfUrl(this.document.id, true, this.$i18n.locale || 'en');
  }

  get pdfPrintUrl() {
    return historyDocumentPdfUrl(this.document.id, false,this.$i18n.locale || 'en');
  }

  get dropdownControlId(): string {
    return `dropdown_doc_${this.document.id}`;
  }

  get hasControls() {
    return this.document.historyBeneficiarySearchAvailable
      || this.document.repeatable || this.pdfAvailable;
  }

  get dropdownControlIdLink(): string {
    return `#${this.dropdownControlId}`;
  }

  get repeatLIClass(): any {
    return {disabled: !this.document.repeatable};
  }
}
</script>

<style scoped lang="less">

.dropdown_accounts {
  ::v-deep {
    .dropdown-menu-right {
      border-top: 3px solid #80bd1c !important;
    }
    a {
      min-width: 150px;
      width: fit-content;
      white-space: nowrap;
    }
  }
}

.dropdown {
  > a.dropdown-trigger {
    cursor: pointer;
    cursor: hand;
  }


  .dropdown-menu {
    padding: 9px 0 11px 0;
    right: initial;
    left: initial;
    min-width: auto;

    li {
      padding: 0;

      a {
        padding: 5px 20px;
      }
    }

    li {
      word-break: normal;
      white-space: nowrap;
    }
  }
}


</style>

<i18n>
{
  "en": {
    "Повторить платеж": "Repeat payment",
    "Поиск по этому корреспонденту": "Search by this correspondent",
    "Скачать PDF документ": "Download PDF document",
    "Печать PDF документа": "Print PDF document",
    "Скачать PDF": "Download PDF",
    "Печать PDF": "Print PDF"
  }
}
</i18n>
